import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
// import moment from 'moment';
import rolling from './helpers/rolling';

import lineClamp from 'vue-line-clamp'

Vue.use(lineClamp)
Vue.use(require('vue-moment'));
Vue.config.productionTip = false;

const rollingPlugin = {
  install () {
    Vue.rolling = rolling
    Vue.prototype.$rolling = rolling
  }
}

Vue.use(rollingPlugin)

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
